import { useTheme } from 'next-themes'
import { LuSun, LuMoon, LuMonitor } from 'react-icons/lu'
import { Box, Stack, Heading, Text, SimpleGrid, Icon, RadioHeader } from '@/components/lib'

const options = [
  {
    value: 'light',
    title: 'Light',
    icon: LuSun,
    description: 'Always use the light theme.'
  },
  {
    value: 'dark',
    title: 'Dark',
    icon: LuMoon,
    description: 'Always use the dark theme.'
  },
  {
    value: 'system',
    title: 'System',
    icon: LuMonitor,
    description: 'Follow your device\'s system preference.'
  }
]

export default function Appearance () {
  const { theme, setTheme } = useTheme()

  return (
    <Stack gap={5}>
      <Box rounded='lg' borderWidth='1px' p={5} bg='bg.subtle'>
        <Heading as='h3' size='md' mb={1}>Theme</Heading>
        <Text color='fg.muted' mb={5}>Choose how Trialflare looks for you.</Text>
        <SimpleGrid columns={3} gap={4}>
          {options.map(opt => (
            <Box
              key={opt.value}
              rounded='md'
              shadow='sm'
              bg='bg.surface'
              p={4}
              borderWidth='2px'
              borderColor={theme === opt.value ? 'primary.solid' : 'border.default'}
              cursor='pointer'
              onClick={() => setTheme(opt.value)}
              transition='border-color 0.15s'
            >
              <RadioHeader
                checked={theme === opt.value}
                onChange={() => setTheme(opt.value)}
                title={opt.title}
                content={
                  <Stack alignItems='center' gap={2} mt={2}>
                    <Icon fontSize='2xl' color={theme === opt.value ? 'primary.fg' : 'fg.muted'}>
                      <opt.icon />
                    </Icon>
                    <Text fontSize='sm' color='fg.muted'>{opt.description}</Text>
                  </Stack>
                }
              />
            </Box>
          ))}
        </SimpleGrid>
      </Box>
    </Stack>
  )
}
